export const PARAM_MEMBER_ID = '{memberId}';
export const PARAM_MEMBER_SLUG = '{memberSlug}';
